import script from "./doorpointsDeduc.vue?vue&type=script&setup=true&lang=js"
export * from "./doorpointsDeduc.vue?vue&type=script&setup=true&lang=js"

import "./doorpointsDeduc.vue?vue&type=style&index=0&id=588d46fa&lang=scss"

const __exports__ = script;

export default __exports__